import React, { useState,useEffect,useRef, useCallback } from 'react';
import { Row, Col } from "react-bootstrap";
import { AnimatePresence,motion } from 'framer-motion';
import useEmblaCarousel from 'embla-carousel-react';

import '../lib/bootstrap.min.css'
import './Main.css';
import './SubPage.css';

const Transport = (props) => {

    const ref = useRef(null);
    const [height,setHeight] = useState(0)
    const [width,setWidth] = useState(0)

    const [emblaRef, emblaApi] = useEmblaCarousel()

    const scrollPrev = useCallback(() => {
      if (emblaApi) emblaApi.scrollPrev()
    }, [emblaApi])
  
    const scrollNext = useCallback(() => {
      if (emblaApi) emblaApi.scrollNext()
    }, [emblaApi])

    useEffect(() => {
        setHeight(ref.current.clientHeight);
        setWidth(ref.current.clientWidth);
    }, []);

  return (
    <AnimatePresence>
        <Row>
            <Col md={12}>
                <motion.div 
                    ref={ref}
                    className='content-subpage'
                    style={{height:(props.height)+'px'}}
                    initial={{ opacity: 0, marginTop:-50 }}
                    animate={{ opacity: 1, marginTop: 0,  }}
                    exit={{opacity:0, marginTop:300}}
                    transition={{ duration: 1.2, ease: [0.87, 0, 0.13, 1] }}
                >
                    <div className="embla">
                        <div className="embla__viewport" ref={emblaRef}>
                            <div className="embla__container">
                                {props.profile.map((transport,key)=>(
                                    <div className="embla__slide" key={key} style={{height:props.height}}>
                                        <img src={transport.value} style={{width:'100%'}} />
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='embla__nav' style={{width:width}}>
                            <button className="embla__prev btnFNB" onClick={scrollPrev}>
                                &laquo; Prev
                            </button>
                            <button className="embla__next btnFNB" onClick={scrollNext}>
                                Next &raquo;
                            </button>
                            {/*<button className="btnFNB" onClick={scrollNext}>
                                How to Order ? 
                            </button>*/}
                        </div>
                    </div>

                </motion.div>
            </Col>
        </Row>
    </AnimatePresence>
  )};

export default Transport;


